// The site's shared behaviour: phone menu, things that fade up and count up as they come into view, add to cart
// without leaving the page, filter chips, the tooltip, and the wireframe spinner for machines without a 3D model.
// Talks to: Shopify's cart endpoints (/cart/add.js, /cart.js); window.MM from layout/theme.liquid.

(() => {
  const MM = (window.MM = window.MM || {});
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches || document.documentElement.classList.contains("static");
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  MM.$ = $; MM.$$ = $$;

  // ---------- numbers ----------
  MM.fmt = (v, digits = 0) => Number(v).toLocaleString("en-US", { minimumFractionDigits: digits, maximumFractionDigits: digits });
  MM.money = (v) => "$" + MM.fmt(Math.round(v), 0);

  // ---------- phone menu ----------
  const menuBtn = $("[data-menu-btn]"), drawer = $("[data-drawer]");
  if (menuBtn && drawer) {
    menuBtn.addEventListener("click", () => {
      const open = drawer.classList.toggle("open");
      menuBtn.setAttribute("aria-expanded", open);
      document.body.style.overflow = open ? "hidden" : "";
    });
    drawer.addEventListener("click", (e) => { if (e.target.closest("a")) { drawer.classList.remove("open"); document.body.style.overflow = ""; } });
  }

  // ---------- in view: fade up, count up, draw ----------
  function countUp(el) {
    const to = parseFloat(el.dataset.countTo), digits = parseInt(el.dataset.digits || "0", 10);
    if (isNaN(to)) return;
    if (reduce) { el.textContent = MM.fmt(to, digits); return; }
    const t0 = performance.now(), dur = 1100 + Math.min(900, to * 4);
    const tick = (t) => {
      const k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3);
      el.textContent = MM.fmt(to * e, digits);
      if (k < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }
  MM.countUp = countUp;
  const io = "IntersectionObserver" in window ? new IntersectionObserver((entries) => {
    for (const en of entries) {
      if (!en.isIntersecting) continue;
      const el = en.target;
      el.classList.add("in");
      if (el.dataset.countTo) countUp(el);
      el.dispatchEvent(new CustomEvent("mm:inview"));
      io.unobserve(el);
    }
  }, { rootMargin: "0px 0px -8% 0px", threshold: 0.12 }) : null;
  MM.watch = (el) => { if (io) io.observe(el); else { el.classList.add("in"); if (el.dataset.countTo) countUp(el); el.dispatchEvent(new CustomEvent("mm:inview")); } };
  $$(".reveal, [data-count-to], .draw").forEach(MM.watch);

  // ---------- tooltip ----------
  const tipEl = $("#tip");
  MM.tip = {
    show(html, ev) {
      if (!tipEl) return;
      tipEl.innerHTML = html; tipEl.hidden = false;
      const r = tipEl.getBoundingClientRect();
      let x = ev.clientX + 14, y = ev.clientY + 14;
      if (x + r.width > innerWidth - 8) x = ev.clientX - r.width - 14;
      if (y + r.height > innerHeight - 8) y = ev.clientY - r.height - 14;
      tipEl.style.left = x + "px"; tipEl.style.top = y + "px";
    },
    hide() { if (tipEl) tipEl.hidden = true; },
    rows(head, rows) {
      return `<div class="h">${head}</div>` + rows.map((r) => `<div class="r">${r.color ? `<i class="sw" style="background:${r.color}"></i>` : ""}<span>${r.name}</span><b>${r.value}</b></div>`).join("");
    },
  };

  // ---------- toast ----------
  const toastEl = $("#toast");
  let toastTimer;
  MM.toast = (html, bad) => {
    if (!toastEl) return;
    toastEl.querySelector(".toast-text").innerHTML = html;
    toastEl.classList.toggle("bad", !!bad);
    toastEl.hidden = false;
    requestAnimationFrame(() => toastEl.classList.add("show"));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toastEl.classList.remove("show"); setTimeout(() => (toastEl.hidden = true), 400); }, 4200);
  };

  // ---------- cart ----------
  async function refreshCount() {
    try {
      const cart = await (await fetch(MM.routes.cart + ".js", { headers: { Accept: "application/json" } })).json();
      $$("[data-cart-count]").forEach((el) => { el.textContent = cart.item_count; el.dataset.count = cart.item_count; });
      return cart;
    } catch { return null; }
  }
  MM.refreshCount = refreshCount;
  document.addEventListener("submit", async (e) => {
    const form = e.target.closest("form.js-product-form, form[data-product-form]");
    if (!form || !window.fetch) return;
    e.preventDefault();
    const btn = form.querySelector("[type=submit]");
    const label = btn && btn.innerHTML;
    if (btn) { btn.setAttribute("aria-disabled", "true"); btn.innerHTML = "Adding…"; }
    try {
      const res = await fetch(MM.routes.cartAdd + ".js", { method: "POST", body: new FormData(form), headers: { Accept: "application/json" } });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || "Couldn't add that to your cart.");
      await refreshCount();
      MM.toast(`Added to cart: ${data.product_title || "item"}. <a class="link" href="${MM.routes.cart}">View cart</a>`);
    } catch (err) {
      MM.toast(err.message, true);
    } finally {
      if (btn) { btn.removeAttribute("aria-disabled"); btn.innerHTML = label; }
    }
  });

  // ---------- filter chips ----------
  // A [data-filters] block holds buttons with data-key/data-value; items in [data-filter-items] carry data-<key>
  // (space-separated values). "all" clears a key. Every active key must match.
  $$("[data-filters]").forEach((box) => {
    const target = document.getElementById(box.dataset.filters);
    if (!target) return;
    const active = {};
    const items = $$("[data-item]", target);
    const empty = $("[data-filter-empty]", target);
    const apply = () => {
      let shown = 0;
      for (const it of items) {
        const ok = Object.entries(active).every(([k, v]) => v === "all" || (it.dataset[k] || "").split(" ").includes(v));
        it.classList.toggle("is-hidden", !ok);
        if (ok) shown++;
      }
      if (empty) empty.classList.toggle("is-hidden", shown > 0);
    };
    box.addEventListener("click", (e) => {
      const b = e.target.closest("button[data-key]");
      if (!b) return;
      active[b.dataset.key] = b.dataset.value;
      $$(`button[data-key="${b.dataset.key}"]`, box).forEach((x) => { x.classList.toggle("on", x === b); x.setAttribute("aria-pressed", x === b); });
      apply();
    });
  });

  // ---------- wireframe spinner ----------
  // A .spin element with data-wire (JSON parts: box, rect, circle, cyl, line; c = frame|dim|accent|hot) draws a line
  // model of a machine that draws itself in, turns slowly, and follows a drag. data-mode="hover" turns only on hover.
  const COLORS = { frame: [195, 194, 183], dim: [139, 137, 131], accent: [57, 135, 229], hot: [235, 104, 52] };
  const ALPHA = { frame: 0.9, dim: 0.42, accent: 0.95, hot: 0.95 };

  function segments(parts) {
    const segs = [];
    const add = (a, b, c) => segs.push([a, b, c]);
    const ring = (cx, cy, cz, r, axis, n) => {
      const pts = [];
      for (let i = 0; i <= n; i++) {
        const t = (i / n) * Math.PI * 2, u = Math.cos(t) * r, v = Math.sin(t) * r;
        pts.push(axis === "x" ? [cx, cy + u, cz + v] : axis === "y" ? [cx + u, cy, cz + v] : [cx + u, cy + v, cz]);
      }
      return pts;
    };
    for (const p of parts) {
      const c = p.c || "frame";
      if (p.box) {
        const [x, y, z, w, h, d] = p.box, X = w / 2, Y = h / 2, Z = d / 2;
        const v = [[-X, -Y, -Z], [X, -Y, -Z], [X, Y, -Z], [-X, Y, -Z], [-X, -Y, Z], [X, -Y, Z], [X, Y, Z], [-X, Y, Z]].map(([a, b, e]) => [x + a, y + b, z + e]);
        [[0, 1], [1, 2], [2, 3], [3, 0], [4, 5], [5, 6], [6, 7], [7, 4], [0, 4], [1, 5], [2, 6], [3, 7]].forEach(([a, b]) => add(v[a], v[b], c));
      } else if (p.rect) {
        const [x, y, z, w, h, plane] = p.rect, W = w / 2, H = h / 2;
        const v = plane === "x" ? [[x, y - H, z - W], [x, y - H, z + W], [x, y + H, z + W], [x, y + H, z - W]]
          : plane === "y" ? [[x - W, y, z - H], [x + W, y, z - H], [x + W, y, z + H], [x - W, y, z + H]]
          : [[x - W, y - H, z], [x + W, y - H, z], [x + W, y + H, z], [x - W, y + H, z]];
        for (let i = 0; i < 4; i++) add(v[i], v[(i + 1) % 4], c);
      } else if (p.circle) {
        const [x, y, z, r, axis] = p.circle, pts = ring(x, y, z, r, axis || "z", 40);
        for (let i = 0; i < pts.length - 1; i++) add(pts[i], pts[i + 1], c);
      } else if (p.cyl) {
        const [x, y, z, r, len, axis, n0] = p.cyl, n = n0 || 24, L = len / 2;
        const off = (k) => (axis === "x" ? [x + k, y, z] : axis === "y" ? [x, y + k, z] : [x, y, z + k]);
        const a = ring(...off(-L), r, axis, n), b = ring(...off(L), r, axis, n);
        for (let i = 0; i < n; i++) { add(a[i], a[i + 1], c); add(b[i], b[i + 1], c); }
        for (let i = 0; i < n; i += Math.max(1, Math.round(n / 6))) add(a[i], b[i], c);
      } else if (p.line) {
        const [x1, y1, z1, x2, y2, z2] = p.line;
        add([x1, y1, z1], [x2, y2, z2], c);
      }
    }
    return segs;
  }

  function spinner(el) {
    let wire;
    try { wire = JSON.parse(el.dataset.wire || "null"); } catch { wire = null; }
    if (!wire || !wire.parts) return;
    const segs = segments(wire.parts);
    let R = 1;
    for (const [a, b] of segs) for (const p of [a, b]) R = Math.max(R, Math.hypot(...p));
    const canvas = document.createElement("canvas");
    canvas.setAttribute("aria-hidden", "true");
    el.append(canvas);
    const ctx = canvas.getContext("2d");
    const hoverOnly = el.dataset.mode === "hover";
    const host = el.closest(el.dataset.hoverHost || ".mcard, .door, a") || el;
    let W = 0, H = 0, dpr = 1;
    let yaw = parseFloat(el.dataset.yaw || "-0.62"), pitch = parseFloat(el.dataset.pitch || "0.32");
    let spinV = hoverOnly ? 0 : 0.0035, target = spinV, drag = null, drawn = reduce ? 1 : 0, visible = false, raf = 0, lastT = 0, t0 = 0;

    const size = () => {
      const r = el.getBoundingClientRect();
      dpr = Math.min(2, devicePixelRatio || 1);
      W = r.width; H = r.height;
      canvas.width = Math.max(1, W * dpr); canvas.height = Math.max(1, H * dpr);
      canvas.style.width = W + "px"; canvas.style.height = H + "px";
    };
    const project = (p, cy, sy, cp, sp, s) => {
      const x1 = p[0] * cy - p[2] * sy, z1 = p[0] * sy + p[2] * cy;
      const y2 = p[1] * cp - z1 * sp, z2 = p[1] * sp + z1 * cp;
      const f = 1 / (1 + z2 / (R * 10));
      return [W / 2 + x1 * s * f, H * 0.5 - y2 * s * f, z2];
    };
    const draw = () => {
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, W, H);
      const s = (Math.min(W, H) * 0.5) / (R * 1.08);
      const cy = Math.cos(yaw), sy = Math.sin(yaw), cp = Math.cos(pitch), sp = Math.sin(pitch);
      // floor shadow
      const g = ctx.createRadialGradient(W / 2, H * 0.86, 0, W / 2, H * 0.86, W * 0.34);
      g.addColorStop(0, "rgba(0,0,0,0.45)"); g.addColorStop(1, "rgba(0,0,0,0)");
      ctx.fillStyle = g; ctx.beginPath(); ctx.ellipse(W / 2, H * 0.86, W * 0.34, H * 0.05, 0, 0, Math.PI * 2); ctx.fill();
      const n = segs.length, upto = drawn * n;
      ctx.lineCap = "round";
      for (let i = 0; i < n && i < upto; i++) {
        const [a, b, c] = segs[i];
        const A = project(a, cy, sy, cp, sp, s), B = project(b, cy, sy, cp, sp, s);
        const part = Math.min(1, upto - i);
        const depth = 0.55 + 0.45 * (1 - ((A[2] + B[2]) / 2 + R) / (2 * R));
        const [r0, g0, b0] = COLORS[c] || COLORS.frame;
        ctx.strokeStyle = `rgba(${r0},${g0},${b0},${(ALPHA[c] || 0.8) * depth})`;
        ctx.lineWidth = c === "dim" ? 1 : 1.4;
        ctx.beginPath(); ctx.moveTo(A[0], A[1]); ctx.lineTo(A[0] + (B[0] - A[0]) * part, A[1] + (B[1] - A[1]) * part); ctx.stroke();
      }
    };
    const loop = (t) => {
      const dt = Math.min(50, t - (lastT || t)); lastT = t;
      if (drawn < 1) { t0 = t0 || t; drawn = Math.min(1, (t - t0) / 1700); }
      spinV += (target - spinV) * 0.06;
      if (!drag && !reduce) yaw += spinV * dt * 0.06;
      draw();
      raf = visible ? requestAnimationFrame(loop) : 0;
    };
    const start = () => { if (!raf) { lastT = 0; raf = requestAnimationFrame(loop); } };
    new ResizeObserver(() => { size(); draw(); }).observe(el);
    new IntersectionObserver((en) => { visible = en[0].isIntersecting; if (visible) start(); }).observe(el);
    if (hoverOnly) {
      host.addEventListener("pointerenter", () => { target = 0.012; start(); });
      host.addEventListener("pointerleave", () => { target = 0; });
    }
    if (el.dataset.drag !== "off") {
      el.style.touchAction = "pan-y"; el.style.cursor = "grab";
      el.addEventListener("pointerdown", (e) => { drag = { x: e.clientX, y: e.clientY, yaw, pitch }; el.setPointerCapture(e.pointerId); el.style.cursor = "grabbing"; });
      el.addEventListener("pointermove", (e) => {
        if (!drag) return;
        yaw = drag.yaw + (e.clientX - drag.x) * 0.01;
        pitch = Math.max(-0.2, Math.min(0.9, drag.pitch + (e.clientY - drag.y) * 0.004));
        start();
      });
      const end = () => { drag = null; el.style.cursor = "grab"; };
      el.addEventListener("pointerup", end); el.addEventListener("pointercancel", end);
    }
    size(); draw();
  }
  MM.spinner = spinner;
  $$(".spin[data-wire]").forEach(spinner);
})();
